import { Component, OnInit } from '@angular/core';
import { MemberService } from 'src/app/services/member.service';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss']
})
export class MembersComponent implements OnInit {
  private perPage=50;
  public loadingMembers:boolean=true;
  public paginatedMembers = new BehaviorSubject<any>(null);
  public availableFilters=[];
  private filterString='';

  constructor(
    private _member: MemberService
  ) {
    this.availableFilters.push(new FilterOption({name:'first_name',type:'string'}));
    this.availableFilters.push(new FilterOption({name:'last_name',type:'string'}));
    this.availableFilters.push(new FilterOption({name:'email',type:'string'}));
  }

  public downloadMembers()
  {
    if(!confirm('Confirm download')) return false;
    this._member.downloadMembersCSV().subscribe(
      (res:any)=>{
        let filename='CentralMembersOutput';
        let blob = new Blob([res], {
          type: 'text/csv;charset=utf-8;'
        });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {
          dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
      }
    );
  }

  public downloadPurchaseData()
  {
    if(!confirm('Confirm download')) return false;
    this._member.downloadPurchaseData().subscribe(
      (res:any)=>{
        let filename='CentralMembersPurchases';
        let blob = new Blob([res], {
          type: 'text/csv;charset=utf-8;'
        });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {
          dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
      }
    );
  }

  public recalcUserPoints()
  {
    if(confirm('Are you sure you want to do this, it is a lengthy and intensive process for the server?'))
    {
      this._member.recalcUserPoints().subscribe(
        res=>{
          console.log(res);
        }
      );
    }
  }

  public getMembers(page){
    this._member.getPaginatedMembers(page, this.perPage, this.filterString).subscribe(
      paginatedData=>{
        this.paginatedMembers.next(paginatedData);
        this.loadingMembers=false;
      }
    );
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getMembers(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getMembers(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getMembers(1);
  }

  ngOnInit() {
    this.getMembers(1);
  }

}
